<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {clone} from '@/utils/helpers'
    import {adult, child} from '~src/utils/tourist-blank-states'

    @Component
    export class BookingTouristsMixin extends Vue {
        setTourists() {
            persistentStore.SET_TOURISTS(this.initTourists(this.searchRequest, clone(persistentStore.tourists)))
        }

        initTourists({adults = 1, childrenAges = []}, tourists, roomIndex = 0) {
            const touristsAdults = tourists.filter(t => t.type === 'adult')
            let i = 0

            for (i; i < adults; i++) {
                if (!touristsAdults[i] || !(touristsAdults[i].firstName || touristsAdults[i].alternativeMealTypeId)) {
                    const user = authStore.user
                    if (
                        i === 0 &&
                        roomIndex === 0 &&
                        authStore.person &&
                        (authStore.person.role === 'client' || user.isEmployeeOrExternalCorp)
                    ) {
                        touristsAdults[0] = this.touristFromPerson(authStore.person) || adult(this.addCitizenship())
                    } else {
                        touristsAdults[i] = adult(this.addCitizenship())

                        if (i === 0) {
                            Object.assign(touristsAdults[i], {phone: null, email: null})
                        }
                    }
                }
            }

            //Сортируем массив возрастов из поиска, чтобы первыми были возраста из заказа, и предзаполняем их первыми
            function customSort(persist, search) {
                const persistSet = new Set(persist)
                const result = []

                for (const item of persist) {
                    if (search.includes(item)) {
                        result.push(item)
                    }
                }

                for (const item of search) {
                    if (!persistSet.has(item)) {
                        result.push(item)
                    }
                }

                return result
            }

            const touristsChildren = tourists.filter(t => t.type === 'child')

            const childrenAgesPersist = touristsChildren.map(c => c.age)
            const childrenAgesSearch = [...childrenAges]

            const childrenAgesSearchSorted = customSort(childrenAgesPersist, childrenAgesSearch)

            childrenAgesSearchSorted.forEach((age, index) => {
                const i = index
                if (!touristsChildren[i] || touristsChildren[i].age !== age) {
                    touristsChildren[i] = child(this.addCitizenship(), age)
                }
            })

            return [...touristsAdults.slice(0, adults), ...touristsChildren.slice(0, childrenAges.length)]
        }

        //TODO Need additional analyse how to refactoring
        touristFromPerson(person) {
            const tourist = runtimeStore.touristFromPerson(person)
            if (!tourist.citizenshipId && !tourist.personId) {
                tourist.citizenshipId = this.searchRequest.citizenshipId
            }
            return Object.assign({}, this.tourLead, tourist)
        }

        addCitizenship() {
            if (persistentStore.selectedCompanyAndAgent?.company.countryId)
                return persistentStore.selectedCompanyAndAgent.company.countryId
            if (this.searchRequest.citizenshipId) return this.searchRequest.citizenshipId
            return authStore.isTO1 || authStore.isAgency || authStore.isCorporate
                ? authStore.company.countryId
                : authStore.person?.countryId || null
        }

        prepareBookTourists(tourists, specifiedTouristBookingFields, includeOptionalTourists = false) {
            const isFieldDisabled = (tourist, index, fieldKey) =>
                runtimeStore.isTouristBookingFieldDisabled(
                    fieldKey,
                    index === 0,
                    tourist.type === 'child',
                    specifiedTouristBookingFields
                )
            return tourists
                .filter(
                    (tourist, index) =>
                        includeOptionalTourists ||
                        !runtimeStore.isTouristNotRequired(tourist, index === 0, specifiedTouristBookingFields)
                )
                .map((tourist, index) => {
                    const newTourist = {...tourist}
                    const {expiryDate, number, issueDate} = tourist.passport
                    if (expiryDate || number || issueDate) {
                        newTourist.passport = {
                            expiryDate,
                            number,
                            issueDate,
                        }
                        if (isFieldDisabled(tourist, index, 'PASSPORT_NUMBER')) delete newTourist.passport.number
                        if (isFieldDisabled(tourist, index, 'PASSPORT_EXPIRE_DATE'))
                            delete newTourist.passport.expiryDate
                        if (isFieldDisabled(tourist, index, 'PASSPORT_ISSUE_DATE')) delete newTourist.passport.issueDate
                        if (!Object.keys(newTourist.passport).length) delete newTourist.passport
                    } else if (
                        !isFieldDisabled(tourist, index, 'PASSPORT_NUMBER') ||
                        !isFieldDisabled(tourist, index, 'PASSPORT_EXPIRE_DATE') ||
                        !isFieldDisabled(tourist, index, 'PASSPORT_ISSUE_DATE')
                    ) {
                        newTourist.passport = {}
                    } else {
                        delete newTourist.passport
                    }
                    if (isFieldDisabled(tourist, index, 'PHONE')) delete newTourist.phone
                    if (isFieldDisabled(tourist, index, 'EMAIL')) delete newTourist.email
                    if (isFieldDisabled(tourist, index, 'PREFIX')) delete newTourist.prefix
                    if (isFieldDisabled(tourist, index, 'CITIZENSHIP')) delete newTourist.citizenshipId
                    if (isFieldDisabled(tourist, index, 'BIRTHDATE')) delete newTourist.birthdate
                    const bookingFields =
                        specifiedTouristBookingFields?.bookingFields || runtimeStore.touristBookingFields.bookingFields
                    if (
                        (bookingFields['AGE'] && isFieldDisabled(tourist, index, 'AGE')) ||
                        newTourist.type !== 'child' ||
                        newTourist.birthdate
                    ) {
                        delete newTourist.age
                    }
                    return newTourist
                })
        }

        get tourLead() {
            return persistentStore.tourists[0]
        }

        set tourLead(val) {
            persistentStore.SET_TOURIST({val, index: 0})
        }

        get tourists() {
            const tourists =
                runtimeStore.touristBookingFields.supplierConfigDetails?.guestsInformationRequiredType ===
                'ONLY_TOURLEAD'
                    ? persistentStore.tourists.slice(0, 1)
                    : persistentStore.tourists
            return tourists.map(
                (tourist, index) =>
                    new Proxy(tourist, {
                        set: (target, prop, val) => {
                            persistentStore.SET_TOURIST_PROP({prop, val, index})
                            return true
                        },
                        get: (target, prop) => {
                            return persistentStore.tourists[index][prop]
                        },
                    })
            )
        }
    }

    export default BookingTouristsMixin
</script>
